"use client";
import React from 'react'

const WebsiteModal = () => {
  return (
    <div id="keyfeatures" className='sm:px-0 px-2 w-full'>
        <h2 className='mb-10 welist-title text-3xl text-center font-bold tracking-wider'>WeList AI Highlights</h2>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 max-w-7xl mx-auto w-full">
            <div className="relative col-span-1 lg:col-span-3 bg-[#4C6EF5] min-h-[500px] lg:min-h-[600px] xl:min-h-[300px] rounded-xl p-4 [background-image:radial-gradient(88%_100%_at_top,rgba(255,255,255,0.3),rgba(255,255,255,0))]">
                <div className="max-w-sm">
                <h2 className="welist-title tracking-wider max-w-sm md:max-w-lg  text-left text-balance text-base md:text-xl lg:text-3xl font-semibold text-white">
                    Supercharge Your Office with WeList AI
                </h2>
                <p className="mt-4 max-w-[26rem] text-left  text-base/6 text-neutral-200">
                    Get it done faster and better with WeList AI! Our AI assistant transform emails and texts into listings instantly with Text-to-Listing.<br />
                    WeList AI generates web descriptions in 4 languages and ranks incoming inquiries. <br />
                    Plus, Smart Feeds connect your listings to Thailand's top web portals.
                </p>
                </div>
                <img
                src="/images/index/laptop.png"
                width={500}
                height={500}
                alt="linear demo image"
                className="absolute sm:right-4 right-0 sm:-bottom-1 bottom-1 object-contain rounded-2xl"
                />
            </div>
            <div
                className="relative col-span-1 lg:col-span-2 h-full [background-image:radial-gradient(88%_100%_at_bottom,rgba(255,255,255,0.3),rgba(255,255,255,0))] bg-[#019DA4] min-h-[500px] lg:min-h-[300px] rounded-xl p-4"         
                style={{
                boxShadow:
                    "0 10px 32px rgba(34, 42, 53, 0.12), 0 1px 1px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(34, 42, 53, 0.05), 0 4px 6px rgba(34, 42, 53, 0.08), 0 24px 108px rgba(47, 48, 55, 0.10)",
                }}
            >
                <div className="max-w-xs">
                <h2 className="welist-title tracking-wider max-w-sm md:max-w-lg  text-left text-balance text-base md:text-xl lg:text-3xl font-semibold text-white">
                    Ultra Fast, Mobile-First Websites
                </h2>
                <p className="mt-4 text-left  text-base/6 text-neutral-200">
                    Over 80% of  your site visitors are on mobile. <br />
                    Get modern, multilingual, SEO-tuned websites that are lightning-fast and easy to search. <br />
                    They are designed to convert visitors into high-yield leads on any device, with easy options to add a niche and agent sites.
                </p>
                </div>
                <img
                    src="/images/index/mobile.png"
                    width={500}
                    height={500}
                    alt="linear demo image"
                    className="absolute sm:h-[350px] h-[320px] z-20 right-1 lg:right-5 sm:bottom-4 -bottom-2 object-contain rounded-2xl"
                />
            </div>
            <div className="col-span-1 min-h-[300px] bg-[#ac205a] rounded-xl p-4 [background-image:radial-gradient(88%_100%_at_bottom,rgba(255,255,255,0.3),rgba(255,255,255,0))]"
                    style={{
                boxShadow:
                    "0 10px 32px rgba(34, 42, 53, 0.12), 0 1px 1px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(34, 42, 53, 0.05), 0 4px 6px rgba(34, 42, 53, 0.08), 0 24px 108px rgba(47, 48, 55, 0.10)",
                }}
            >
                <h2 className="welist-title tracking-wider max-w-sm md:max-w-lg  text-left text-balance text-base md:text-xl lg:text-3xl font-semibold text-white">
                AI Social Marketing: Boost Engagement & Conversions
                </h2>
                <p className="mt-4 max-w-[26rem] text-left  text-base/6 text-neutral-200">
                    Effortlessly create and schedule optimized, even bilingual, social media content with AI.<br />
                    Drive traffic back to your website for greater engagement and higher conversions.
                </p>
            </div>

        </div>
    </div>
  )
}

export default WebsiteModal